/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Language_LabelInputs */



/**
* | output |
* | --- |
* | "Language" |
*
* @param {Profile_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_language_label = /** @type {((inputs?: Profile_Language_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Language_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idioma")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Idioma")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingua")
	return /** @type {LocalizedString} */ ("Language")
});